import dynamic from 'next/dynamic';
import React from 'react';

import { Modal } from '~components/Modals/Base';

import type { NewPasswordModalProps } from '../../model/types';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const NewPasswordModal = ({
	locked,
	onClose,
	open,
	token,
}: NewPasswordModalProps) => {
	return (
		<Modal open={open} locked={locked} onClose={onClose}>
			<Content token={token} open={open} locked={locked} onClose={onClose} />
		</Modal>
	);
};
